<template>
  <div id="my-works">
    <div id="occupied"></div>
    <!-- 报名须知 -->
    <div class="application-note-container">
      <div class="big-title">
        报名须知
      </div>
      <div class="content">
        <div
          class="detail"
          v-for="(award, aw) in myWorksData.awardArr"
          :key="aw"
        >
          <span>{{ award.num }}</span>
          <span class="txt">{{ award.txt }}</span>
        </div>
      </div>
    </div>
    <!-- 报名表 -->
    <div class="form-area">
      <div class="label-choose">
        <ul class="box">
          <li
            v-for="(info, index) in infoArr"
            :key="index"
            :class="{ checked: index == choose }"
            @click="changeList(index)"
          >
            {{ info }}
          </li>
        </ul>
      </div>
      <div class="form-content">
        <template>
          <div class="user-info">
            <div class="big-title">
              {{ choose === 0 ? '个人信息' : '作品信息' }}
            </div>
            <img class="title-img work" :src="titleSrc" />
            <div class="login-box">
              <div class="login-content">
                <span class="label">迷你号：</span>

                <div class="no-login">
                  <span>{{
                    isLogin ? this.$store.getters.currentUser.uin : '您尚未登录'
                  }}</span>
                  <p class="no-login-tip" v-if="!isLogin">
                    登录迷你号才可填写信息
                  </p>
                </div>
              </div>
              <div class="btn-login" v-if="!isLogin" @click="handleLogin">
                登录
              </div>
              <div class="btn-logout" @click="logoutFn" v-if="isLogin">
                【退出】
              </div>
            </div>
          </div>
        </template>

        <UserInfoForm
          @isApply="isApply"
          v-show="choose === 0"
          key="1"
          :isLogin="isLogin"
          @handleTab="handleTab"
        ></UserInfoForm>
        <ContributeForm
          v-show="choose === 1"
          key="2"
          :isLogin="isLogin"
        ></ContributeForm>
      </div>
    </div>
  </div>
</template>

<script>
import { ssoLoing } from '../common/ssoUrl';
import { myWorksData } from '../common/pageData';
import UserInfoForm from '../components/userInfoForm';
import ContributeForm from '../components/contributeForm';
export default {
  name: 'myWorks',
  components: {
    UserInfoForm,
    ContributeForm
  },
  data() {
    return {
      myWorksData: myWorksData,
      infoArr: ['个人信息', '作品信息'],
      choose: 0,
      hasApply: false,
      titleSrc: require('../assets/images/img_title_userInfo.png'),
      msg: ''
    };
  },
  watch: {
    isLogin: function(val) {
      if (val) {
        this.$reportLog(16067);
      }
    },
    $route: {
      handler() {
        this.$reportLog(16067);
      },
      deep: true
    }
  },
  mounted() {
    this.$scroll('occupied');
    window.sessionStorage.setItem(
      'pathName',
      window.location.hash.split('#')[1]
    );
    this.noLoginRep();
  },
  computed: {
    isLogin() {
      if (window.sessionStorage.getItem('currentUser') != 'null') {
        this.$store.commit(
          'userStatus',
          JSON.parse(window.sessionStorage.getItem('currentUser'))
        );
      } else {
        this.$store.commit('userStatus', null);
      }
      return this.$store.getters.isLogin;
    }
  },
  methods: {
    noLoginRep() {
      let isJump = performance.navigation.type; // 0跳转，//1刷新 // 2前进后退
      if (isJump == 0 && this.isLogin) {
        this.$reportLog(16067);
      } else if (isJump != 0) {
        this.$reportLog(16067);
      }
    },
    isApply(val, choose, msg) {
      this.hasApply = val;
      this.choose = choose;
      this.msg = msg;
    },
    handleLogin() {
      ssoLoing();
    },
    // 切换表单
    changeList(index) {
      if (!this.isLogin) {
        this.$Toast('请先登录');
      } else {
        if (!this.hasApply && index === 1) {
          this.$Toast('请先填写报名信息');
          return false;
        } else {
          if (this.hasApply && this.msg) {
            this.$Toast(this.msg);
          } else {
            if (index === 0) {
              this.titleSrc = require('../assets/images/img_title_userInfo.png');
            } else {
              this.titleSrc = require('../assets/images/img_title_work_info.png');
            }
            this.choose = index;
          }
        }
      }
    },
    logoutFn() {
      this.choose = 0;
      this.$sso.clear();
      this.$store.dispatch('setUser', null);
    },
    handleTab(val) {
      this.changeList(Number(val));
    }
  }
};
</script>

<style lang="scss" scoped>
#my-works {
  width: 750px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgb(53, 53, 53);
  font-size: 26px;
  .big-title {
    margin-top: 50px;
    font-size: 60px;
    font-weight: 800;
    color: rgb(53, 53, 53);
  }

  .application-note-container,
  .form-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
  }
  // 报名须知
  .application-note-container {
    .content {
      padding: 30px;

      .detail {
        display: flex;
        margin: 10px 0;
        .txt {
          flex: 1;
        }
      }
    }
  }
  // 表单区域
  .form-area {
    width: 100%;
    margin-bottom: 40px;
    .label-choose {
      width: 100%;
      margin-bottom: 20px;
      ul {
        width: 100%;
        box-shadow: 0px 15px 10px -15px#ff874b;
        font-weight: 600;
        font-size: 34px;
        li {
          width: 50%;
          height: 100px;
          display: inline-block;
          text-align: center;
          line-height: 100px;
          background-color: #e8e8e8;
        }
        li.checked {
          background-color: #ff874b;
          color: #fff;
        }
      }
    }

    .form-content {
      width: 750px;
      .user-info,
      .work-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 30px;
      }
      .title-img {
        height: 12px;
      }
      .user {
        width: 215px;
      }
      .work {
        width: 190px;
      }
    }
  }

  .btn-login {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    width: 150px;
    background-color: #ff874b;
    color: #fff;
    margin-left: 60px;
    font-weight: 600;
    font-size: 30px;
    border-radius: 5px;
  }

  .login-box {
    margin-top: 30px;
    margin-bottom: -20px;
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: center;
    font-size: 36px;
    font-weight: 600;
    .label {
      margin-left: 30px;
    }
    .login-content {
      display: flex;
    }
    .no-login {
      display: flex;
      flex-direction: column;
    }

    .no-login-tip {
      color: red;
      font-size: 24px;
      font-weight: normal;
    }
    .btn-logout {
      margin-left: 40px;
      color: #ff874b;
    }
  }
}
</style>
